export const HEVO_DARK_THEME_LOGO_SVG =
  'https://res.cloudinary.com/hevo/image/upload/v1762931622/dashboard/hevo-logos/svg/white_hxnfzp.svg';
export const HEVO_LIGHT_THEME_LOGO_SVG =
  'https://res.cloudinary.com/hevo/image/upload/v1762931621/dashboard/hevo-logos/svg/dark_a4vovy.svg';

export const HEVO_FAVICON_LIGHT_SVG =
  'https://res.cloudinary.com/hevo/image/upload/v1762932299/dashboard/hevo-favicons/svg/favicon-light_wdwxon.svg';

export const WORKSPACE_URL_SVG =
  'https://res.cloudinary.com/hevo/image/upload/v1778083480/workspace_pkeejm.svg';
